import React from 'react'
import { SegmentedControl } from '../../../../components/SegmentedControl/SegmentedControl'
import { type CcqCard } from './ccqResultView'
import { CCQ_ACTION_FILTER_ALL, CCQ_ACTION_FILTER_LABEL, CCQ_ACTION_FILTER_WITH, CCQ_ACTION_FILTER_WITHOUT, formatCount } from './ccqRunCopy'
import { useCcqWithActionsCount } from './useCcqCardResults'
import { useCcqRun } from './useCcqRun'
import { useCcqCursor } from './useCcqListCursor'
import { CcqActionFilters, type CcqActionFilter } from './useCcqWorkspace'

const SEGMENTS: { filter: CcqActionFilter; label: string }[] = [
  { filter: CcqActionFilters.ALL, label: CCQ_ACTION_FILTER_ALL },
  { filter: CcqActionFilters.WITH, label: CCQ_ACTION_FILTER_WITH },
  { filter: CcqActionFilters.WITHOUT, label: CCQ_ACTION_FILTER_WITHOUT },
]

interface CcqActionFilterControlProps {
  card: CcqCard
  onChange: () => void
}

export const CcqActionFilterControl: React.FC<CcqActionFilterControlProps> = ({ card, onChange }) => {
  const { filter: actionFilter, setFilter: setActionFilter } = useCcqCursor().list
  const { counts: cardCounts } = useCcqRun()
  const withActions = useCcqWithActionsCount(card)
  const all = cardCounts[card]
  const counts: Record<CcqActionFilter, number> = { all, with: withActions, without: Math.max(all - withActions, 0) }

  const handleSelect = (key: string) => {
    const filter = SEGMENTS.find((segment) => segment.filter === key)?.filter
    if (filter === undefined || filter === actionFilter) {
      return
    }
    setActionFilter(filter)
    onChange()
  }

  return (
    <div className='flex-shrink-0'>
      <SegmentedControl
        options={SEGMENTS.map(({ filter, label }) => ({ key: filter, label, count: formatCount(counts[filter]) }))}
        activeKey={actionFilter}
        ariaLabel={CCQ_ACTION_FILTER_LABEL}
        onSelect={handleSelect}
        size='compact'
      />
    </div>
  )
}
